import React, { useEffect, useState } from 'react'

import { i18nextContainer } from 'shared/configs/i18n/config'

import { getCurrentDateTime } from './DateTime.helpers'
import styles from './DateTime.module.scss'

export const DateTime = () => {
  const { date, time } = getCurrentDateTime()

  const [currentDate, setCurrentDate] = useState(date)
  const [currentTime, setCurrentTime] = useState(time)

  useEffect(() => {
    const interval = setInterval(() => {
      const { date, time } = getCurrentDateTime()
      setCurrentDate(prevDate => {
        if (date !== prevDate) return date
        return prevDate
      })
      setCurrentTime(prevTime => {
        if (time !== prevTime) return time
        return prevTime
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    const handleLanguageChange = () => {
      const { date, time } = getCurrentDateTime()
      setCurrentDate(date)
      setCurrentTime(time)
    }

    i18nextContainer.on('languageChanged', handleLanguageChange)
    return () => {
      i18nextContainer.off('languageChanged', handleLanguageChange)
    }
  }, [])

  return (
    <div className={styles.dateTime}>
      <span className={styles.time}>{currentTime}</span>
      <span className={styles.date}>{currentDate}</span>
    </div>
  )
}
